import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface ParticipantTabState {
  categoryType: string;
  menuType: string;

  toggleLoader: boolean;

  canManageDoctors: boolean;
  canAssignConsent: boolean;
  canChat: boolean;
  canManageAppointments: boolean;

  siteId: string;
}

const initialState: ParticipantTabState = {
  categoryType: "",
  menuType: "",

  toggleLoader: false,

  canManageDoctors: false,
  canAssignConsent: false,
  canChat: false,
  canManageAppointments: false,
  siteId: "",
};

const getIntialState = (): ParticipantTabState => {
  const categoryType = sessionStorage?.getItem("category-type") ?? "";
  const menuType = sessionStorage?.getItem("menu-type") ?? "";
  return {
    ...initialState,
    categoryType,
    menuType,
  };
};

export const participantTabSlice = createSlice({
  name: "participantTab",
  initialState: getIntialState(),
  reducers: {
    setTabCategoryType: (state, action: PayloadAction<string>) => {
      state.categoryType = action.payload;
    },
    setTabMenuType: (state, action: PayloadAction<string>) => {
      state.menuType = action.payload;
    },
    setToggleLoader: (state) => {
      state.toggleLoader = !state.toggleLoader;
    },
    setParticipantPermissions: (
      state,
      action: PayloadAction<{
        canManageDoctors: boolean;
        canAssignConsent: boolean;
        canChat: boolean;
        canManageAppointments: boolean;
      }>,
    ) => {
      state.canManageDoctors = action.payload.canManageDoctors;
      state.canAssignConsent = action.payload.canAssignConsent;
      state.canChat = action.payload.canChat;
      state.canManageAppointments = action.payload.canManageAppointments;
    },
    setSiteId: (state, action: PayloadAction<string>) => {
      state.siteId = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setTabCategoryType,
  setTabMenuType,
  setToggleLoader,
  setParticipantPermissions,
  setSiteId,
  reset,
} = participantTabSlice.actions;

export default participantTabSlice.reducer;
